const PREFIX = 'SHOPPING_CART_';

export const SHOPPING_CART_ACTIONS = {
  ADD_COURSE_TO_CART: `${PREFIX}ADD_COURSE_TO_CART`,
  REMOVE_COURSE_FROM_CART: `${PREFIX}REMOVE_COURSE_FROM_CART`,
  SET_LOADING_CART_MUTATION: `${PREFIX}SET_LOADING_CART_MUTATION`,
  SET_LOADING_CART: `${PREFIX}SET_LOADING_CART`,
  SET_LAST_ITEM_ADDED: `${PREFIX}SET_LAST_ITEM_ADDED`,
  SET_LAST_ITEM_ADDED_TYPE: `${PREFIX}SET_LAST_ITEM_ADDED_TYPE`,
  SET_STATE: `${PREFIX}SET_STATE`,
  SET_SHOW_SHOPPING_CART_POPUP: `${PREFIX}SET_SHOW_SHOPPING_CART_POPUP`,
  SET_FETCH_SHOPPING_CART_POPUP_CHUNK: `${PREFIX}SET_FETCH_SHOPPING_CART_POPUP_CHUNK`,
  SET_FLAG_CLASSIC_SHOPPING_CART: `${PREFIX}SET_FLAG_CLASSIC_SHOPPING_CART`,
};

export const shoppingCartReducer = (state, action) => {
  switch (action.type) {
    case SHOPPING_CART_ACTIONS.SET_LOADING_CART_MUTATION:
      return {
        ...state,
        loadingCartMutation: action.status,
      };
    case SHOPPING_CART_ACTIONS.SET_LOADING_CART:
      return {
        ...state,
        loadingCart: action.status,
      };
    case SHOPPING_CART_ACTIONS.SET_LAST_ITEM_ADDED:
      return {
        ...state,
        lastItemAdded: action.item,
      };
    case SHOPPING_CART_ACTIONS.SET_LAST_ITEM_ADDED_TYPE:
      return {
        ...state,
        lastItemAddedType: action.itemType,
      };
    case SHOPPING_CART_ACTIONS.SET_STATE:
      return {
        ...state,
        ...action.state,
      };
    case SHOPPING_CART_ACTIONS.SET_SHOW_SHOPPING_CART_POPUP:
      return {
        ...state,
        showShoppingCartPopup: action.visibility,
      };
    case SHOPPING_CART_ACTIONS.SET_FETCH_SHOPPING_CART_POPUP_CHUNK:
      return {
        ...state,
        fetchShoppingCartPopupChunk: action.visibility,
      };
    case SHOPPING_CART_ACTIONS.SET_FLAG_CLASSIC_SHOPPING_CART:
      return {
        ...state,
        flagClassicShoppingCart: action.status,
      };
    default:
      return state;
  }
};
